var codeblock_default = {
  "blockStyleSpacing": "_0JO1V",
  "codeBlock": "vMTcR _0JO1V",
  "renderedInTable": "B---H"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
